import { render } from "./WidgetsFinancePanel.vue?vue&type=template&id=7211d121&scoped=true"
import script from "./WidgetsFinancePanel.vue?vue&type=script&lang=js"
export * from "./WidgetsFinancePanel.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7211d121"

export default script